import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import Filters from "./Table/Filters";
import columns from "./Table/columns";
import data from "./Table/data";

import { useAdminContext } from "../../../contexts/AdminContext";

export default function Table() {
  const { dispatch, actions, state } = useAdminContext();

  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    actions.loadAdmins(dispatch);
  }, []);

  return (
    <>
      <Filters keyword={keyword} setKeyword={setKeyword} />
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={data(state.admins, keyword) || []}
          noDataComponent={
            <div className="mt20">
              {state.admins == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
